import React, { PropTypes } from 'react';
import HelpLinkContainer from '../../../../containers/HelpLinkContainer';
import AccountSwitcherContainer from '../../../../containers/AccountSwitcherContainer';
import BorrowingTitle from '../BorrowingTitle';

import './BorrowingHeader.scss';

export default function BorrowingHeader({ headingKey, taglineKey, helpLinkPage }) {
  return (
    <div className="cp-borrowing-header">
      <div className="title-and-faqs">
        <BorrowingTitle headingKey={headingKey} taglineKey={taglineKey} />
        { helpLinkPage && (<HelpLinkContainer page={helpLinkPage} />) }
      </div>

      <div className="right-controls">
        <AccountSwitcherContainer />
      </div>
    </div>
  );
}

BorrowingHeader.propTypes = {
  headingKey: PropTypes.string,
  taglineKey: PropTypes.string,
  helpLinkPage: PropTypes.string
};




// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingHeader/BorrowingHeader.jsx